export default __webpack_public_path__ + "static/media/memchache.52dce7ca.svg";